export default class WorkInformationController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/workInformation/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/delete', 'post', params, axiosOption, httpOption);
  }

  static deleteBatch (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/deleteBatch', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/startOnly/flowWorkInformation', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/startWithBusinessKey/flowWorkInformation', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/startAndTakeUserTask/flowWorkInformation', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/startAndSaveDraft/flowWorkInformation', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/submitUserTask/flowWorkInformation', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/viewTaskBusinessData/flowWorkInformation', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/viewHistoricTaskBusinessData/flowWorkInformation', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowWorkInformation (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/workInformation/listWorkOrder/flowWorkInformation', 'post', params, axiosOption, httpOption);
  }
}
